export const SPEC_IMAGE_CAMERA_ANGLES = {
    UNKNOWN: "unknown",
    OTHER: "other",

    EXTERIOR_FRONT: "front",
    EXTERIOR_REAR: "rear",

    EXTERIOR_SIDE_DRIVER: "side-driver",
    EXTERIOR_SIDE_PASSENGER: "side-passenger",

    EXTERIOR_PERSPECTIVE_FRONT_DRIVER: "perspective-front-driver",
    EXTERIOR_PERSPECTIVE_FRONT_PASSENGER: "perspective-front-passenger",
    EXTERIOR_PERSPECTIVE_BACK_DRIVER: "perspective-back-driver",
    EXTERIOR_PERSPECTIVE_BACK_PASSENGER: "perspective-back-passenger",

    // Almost side pictures, but a little bit perspective
    EXTERIOR_PERSPECTIVE_SIDE_FRONT_PASSENGER: "perspective-front-side-passenger",
    EXTERIOR_PERSPECTIVE_SIDE_FRONT_DRIVER: "perspective-front-side-driver",
    EXTERIOR_PERSPECTIVE_SIDE_BACK_PASSENGER: "perspective-back-side-passenger",
    EXTERIOR_PERSPECTIVE_SIDE_BACK_DRIVER: "perspective-back-side-driver",

    // Almost front picture, but with a little bit of perspective
    EXTERIOR_PERSPECTIVE_FRONT_SIDE_PASSENGER: "perspective-almost-front-side-passenger",
    EXTERIOR_PERSPECTIVE_FRONT_SIDE_DRIVER: "perspective-almost-front-side-driver",

    EXTERIOR_CLOSE_UP_WHEEL: "perspective-close-up-wheel",

    INTERIOR_FROM_DRIVER_TO_FRONT: "interior-driver-to-front",
    INTERIOR_FROM_DRIVER_TO_DASHBOARD: "interior-driver-to-dashboard",
    INTERIOR_SEETHROUGH_SIDE_PASSENGER: "interior-seethrough-side-passenger",

    INTERIOR_PANORAMIC_360: 'interior-panoramic-360',

    DETAIL_MAIN_DISPLAY: "main-display",
    DETAIL_BED_FLOOR: "bed-floor-contour",
    DETAIL_ENGINE: "engine",
    DETAIL_HEADLIGHT: "headlight",
    DETAIL_RIM: "rim",
};
